var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11.2493C11.4662 11.2493 10.625 10.4081 10.625 9.37432C10.625 8.34057 11.4662 7.49932 12.5 7.49932C13.5337 7.49932 14.375 8.34057 14.375 9.37432C14.375 10.4081 13.5337 11.2493 12.5 11.2493M12.5 4.99943C10.0875 4.99943 8.125 6.96193 8.125 9.37443C8.125 11.7869 10.0875 13.7494 12.5 13.7494C14.9125 13.7494 16.875 11.7869 16.875 9.37443C16.875 6.96193 14.9125 4.99943 12.5 4.99943M12.5 22.0575C10.4062 20.0775 4.99996 14.5187 4.99996 9.90246C4.99996 5.82121 8.36371 2.49996 12.5 2.49996C16.6362 2.49996 20 5.82121 20 9.90246C20 14.5187 14.5937 20.0775 12.5 22.0575M12.5 0C6.98625 0 2.5 4.44125 2.5 9.9025C2.5 16.7462 11.3112 24.3762 11.6862 24.6975C11.9212 24.8987 12.21 25 12.5 25C12.79 25 13.0787 24.8987 13.3137 24.6975C13.6887 24.3762 22.5 16.7462 22.5 9.9025C22.5 4.44125 18.0137 0 12.5 0",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.307f359d460f13ea7abb35cfccd14b04.svg";
export { ForwardRef as ReactComponent };